// Fetch list

export const FETCH = 'vehicleFleetboardConfigurations.FETCH'
export const FETCH_STARTED = 'vehicleFleetboardConfigurations.FETCH_STARTED'
export const FETCH_FULFILLED = 'vehicleFleetboardConfigurations.FETCH_FULFILLED'
export const FETCH_REJECTED = 'vehicleFleetboardConfigurations.FETCH_REJECTED'
export const FETCH_CANCELLED = 'vehicleFleetboardConfigurations.FETCH_CANCELLED'

export const SORTING_CHANGED = 'vehicleFleetboardConfigurations.SORTING_CHANGED'

// Fetch one

export const FETCH_ONE = 'vehicleFleetboardConfigurations.FETCH_ONE'
export const FETCH_ONE_STARTED = 'vehicleFleetboardConfigurations.FETCH_ONE_STARTED'
export const FETCH_ONE_FULFILLED = 'vehicleFleetboardConfigurations.FETCH_ONE_FULFILLED'
export const FETCH_ONE_REJECTED = 'vehicleFleetboardConfigurations.FETCH_ONE_REJECTED'
export const FETCH_ONE_CANCELLED = 'vehicleFleetboardConfigurations.FETCH_ONE_CANCELLED'

// Save

export const SAVE = 'vehicleFleetboardConfigurations.SAVE'
export const SAVE_STARTED = 'vehicleFleetboardConfigurations.SAVE_STARTED'
export const SAVE_FULFILLED = 'vehicleFleetboardConfigurations.SAVE_FULFILLED'
export const SAVE_REJECTED = 'vehicleFleetboardConfigurations.SAVE_REJECTED'
export const SAVE_CANCELLED = 'vehicleFleetboardConfigurations.SAVE_CANCELLED'

// Delete

export const DELETE = 'vehicleFleetboardConfigurations.DELETE'
export const DELETE_STARTED = 'vehicleFleetboardConfigurations.DELETE_STARTED'
export const DELETE_FULFILLED = 'vehicleFleetboardConfigurations.DELETE_FULFILLED'
export const DELETE_REJECTED = 'vehicleFleetboardConfigurations.DELETE_REJECTED'
export const DELETE_CANCELLED = 'vehicleFleetboardConfigurations.DELETE_CANCELLED'
